import get from 'lodash/get'
const getListEventsQueryParams = (query: any) =>{

    const pageNo = query.page + 1;
    let sortDirection = 'ascending';
    let sortBy = 'name'
    if(query.orderDirection === 'desc'){
        sortDirection = 'descending'
    }
    if(get(query, 'orderBy.field') === 'startTime'){
        sortBy = 'event-start'
    }

    if(get(query,'orderBy.field') === 'endTime'){
        sortBy = 'event-end'
    }
    return {sortDirection, sortBy, pageNo}
}

export default getListEventsQueryParams;